function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import useMergeState from '@restart/hooks/useMergeState';
import Konva from 'konva';
import React, { useContext, useEffect, useMemo } from 'react';
import { Stage as BaseStage } from 'react-konva'; // @ts-ignore
// eslint-disable-next-line no-underscore-dangle

Konva._pointerEventsEnabled = true;
const StageContext = React.createContext({
  cursor: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCursor: () => {}
});
export function useStageSettings({
  cursor
}) {
  const {
    setCursor
  } = useContext(StageContext);
  useEffect(() => {
    setCursor(cursor);
  }, [cursor, setCursor]);
}
export const ToolStageDimensionContext = React.createContext({
  width: 0,
  height: 0
});

/**
 * Wraps the Konva Stage component to allow for some more ergonomic APIs to common
 * Stage-level attributes such as `cursor`
 */
export default function ToolStage({
  children,
  cursor,
  style,
  width,
  height,
  ...props
}) {
  const dimensions = useMemo(() => ({
    width,
    height
  }), [width, height]);
  const [state, setState] = useMergeState({
    cursor: null,
    setCursor: nextCursor => {
      setState(s => s.cursor !== nextCursor ? {
        cursor: nextCursor
      } : null);
    }
  });
  return React.createElement(BaseStage, _extends({}, props, dimensions, {
    style: { ...style,
      ...dimensions,
      cursor: state.cursor || cursor || undefined
    }
  }), React.createElement(ToolStageDimensionContext.Provider, {
    value: dimensions
  }, React.createElement(StageContext.Provider, {
    value: state
  }, children)));
}